'use strict';

var messageModule = angular.module('t2g.message', [
    'gettext',
    'ui.router',
    require('t2g.common.services.notificationService').name,
    require('t2g.common.services.modalService').name
]);

module.exports = messageModule;

messageModule.controller('MailCtrl', require('./types/MailCtrl'));
messageModule.controller('MessageBoxCtrl', require('./MessageBoxCtrl'));
messageModule.controller('MessageCtrl', require('./types/MessageCtrl'));
messageModule.controller('SMSCtrl', require('./types/SMSCtrl'));

messageModule.config(function($stateProvider) {
    $stateProvider
        .state('private.main.messages', {
            url: '/message/:box/?:date',
            title: 'Messages',
            templateUrl: 'https://cdn.termin2go.com/app/app/modules/message/MessageBoxView.html?v=3.73.1',
            controller: 'MessageBoxCtrl as MessageBoxCtrl',
            resolve: {
                messagesResolve: function($stateParams, Message) {
                    var date = $stateParams.date ? $stateParams.date : moment().format('YYYY-MM-DD');
                    return Message.get($stateParams.box, date);
                }
            }
        })
        .state('private.main.message', {
            url: '/message/',
            title: 'Messages',
            controller: 'MessageCtrl as MessageCtrl',
            templateUrl: 'https://cdn.termin2go.com/app/app/modules/message/types/MessageView.html?v=3.73.1'
        })
        .state('private.main.message.mail', {
            url: 'mail/:messageId',
            title: 'Messages',
            controller: 'MailCtrl as MailCtrl',
            templateUrl: 'https://cdn.termin2go.com/app/app/modules/message/types/MailView.html?v=3.73.1',
            resolve: {
                messageResolve: function($stateParams, Message) {
                    return Message
                      .getOne($stateParams.messageId)
                      .then(function(m){
                          return m;
                      })
                }
            }
        })
        .state('private.main.message.sms', {
            url: 'sms/:messageId',
            title: 'Messages',
            controller: 'SMSCtrl as SMSCtrl',
            templateUrl: 'https://cdn.termin2go.com/app/app/modules/message/types/SMSView.html?v=3.73.1',
            resolve: {
                messageResolve: function($stateParams, Message) {
                    return Message.getOne($stateParams.messageId);
                }
            }
        });
});
